export enum ScheduleDayKeys {
  Index = 'index',
  Name = 'name',
  Start = 'start',
  End = 'end',
  Slug = 'slug',
}
